import { crudRequest } from '@/services/api';
import { getToDay } from '@/utils/date';

const dataRange = getToDay()
const paramsForm = {
  provinceArea: undefined, //  { name: '浙江经营本部' },
  stayStoreType: 0,
  // dataRange
  startDate: dataRange[0].format('YYYY-MM-DD 12:00:00'),
  endDate: dataRange[1].format('YYYY-MM-DD 12:00:00'),
}
export default {
  namespace: 'staystorecause',
  state: {
    searchParams: { ...paramsForm },
  },

  effects: {
    *getData(_, { call, put, select }) {

    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}